// Where the Ride desk answers, as paths a limiter and a browser can both name.
//
// Its own module importing nothing, on admin/endpoints.ts's reasoning: the
// rate limiter has to name these urls, and routes.ts has to read the limiter,
// so putting the strings beside Fastify would close a cycle.
//
// NOT A REPORT AND NOT IN REPORT_ENDPOINTS. The four reports file
// `report_access`. This desk reads FortNine Firestore through a proxy, files
// no disclosure in Postgres, and is nova_admin only for the same reason Data
// is. Folding it into ReportName would put a url that does not exist as a
// report into REPORT_ENDPOINTS and inherit an audit row this read does not
// write.
//
// Five urls rather than a query on one, because the rate limiter keys on the
// url and a list is not the same cost as one rider's every run, the tape, the
// mail switches, or the public arcade board.

export const RIDE_ENDPOINTS = {
  listRiders: "/v1/admin/activations/:activationId/ride/riders",
  readRider: "/v1/admin/activations/:activationId/ride/riders/:riderId",
  listActivity: "/v1/admin/activations/:activationId/ride/activity",
  mail: "/v1/admin/activations/:activationId/ride/mail",
  board: "/v1/admin/activations/:activationId/ride/board",
  /**
   * The verified board for this activation, placed over a window (12 Oct
   * hand-off: every column sorts, on the server). Placing is ordering, so it
   * moved here from the console with the sort: the page drew a board it had
   * ranked itself out of two reads.
   */
  places: "/v1/admin/activations/:activationId/ride/places",
} as const;

// ------------------------------------------------------------ what sorts
//
// Each list's columns, as the keys its `sort` takes (12 Oct hand-off: every
// column sorts, on the server). Here, beside the urls and importing nothing,
// so the console names the same keys the proxy allow-lists. ride/order.ts has
// the rule; ride/routes.ts says what each key reads.

/** Players: Tag, Player, Best, Runs, Claimed. */
export const RIDE_RIDER_SORT_KEYS = ["tag", "player", "best", "runs", "claimed"] as const;
export type RideRiderSortKey = (typeof RIDE_RIDER_SORT_KEYS)[number];

/** Activity's runs: When, Tag, Email, Score, Finished, Verified, Hits, Pickups, Bike, Top, Jumps. */
export const RIDE_RUN_SORT_KEYS = [
  "when",
  "tag",
  "email",
  "score",
  "finished",
  "verified",
  "hits",
  "pickups",
  "bike",
  "top",
  "jumps",
] as const;
export type RideRunSortKey = (typeof RIDE_RUN_SORT_KEYS)[number];

/** Activity's finish codes, as `codes_sort`: Code, Tag, Off, Why, Issued. */
export const RIDE_CODE_SORT_KEYS = ["code", "tag", "off", "why", "issued"] as const;
export type RideCodeSortKey = (typeof RIDE_CODE_SORT_KEYS)[number];

/** The verified board: Place, Tag, Player, Best, Runs in window. */
export const RIDE_PLACE_SORT_KEYS = ["place", "tag", "player", "score", "runs"] as const;
export type RidePlaceSortKey = (typeof RIDE_PLACE_SORT_KEYS)[number];

/** The arcade board, as the game site ranks it: Place, Tag, Score. */
export const RIDE_BOARD_SORT_KEYS = ["place", "tag", "score"] as const;
export type RideBoardSortKey = (typeof RIDE_BOARD_SORT_KEYS)[number];

/** The windows the verified board is placed over. */
export const RIDE_PLACE_WINDOWS = ["allTime", "monthly", "weekly", "custom"] as const;
export type RidePlaceWindow = (typeof RIDE_PLACE_WINDOWS)[number];

// Ride is the first game on this desk. A later activation whose game is not
// Ride gets a sibling module and its own segment — not a flag on these urls.
